import { MobileSectorVm } from '@app/entities/bus-results';

export function busesCabinsMapper(routes: MobileSectorVm[]): string[] {
  return routes.map(r => r.Flights.reduce((arr, f) => [ ...arr, f.Cabin], [])).reduce((arr, r) => [...arr, r], []);
}
